import { Component, inject, Input, OnInit } from '@angular/core';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  ModalController,
} from '@ionic/angular/standalone';
import {
  getHorlogeTotalTime,
  transformPompeVSWeekBufferToModel,
  transformPompeVSWeekModelToBuffer,
  VSHorlogeModel,
} from '../../../../../helper/horloge';
import { convertMinutesToTime } from '../../../../../helper/convertSecondsToTime';
import Moment from 'moment';
import { AppComponent } from '../../../../../../../app.component';
import moment from 'moment';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import { TranslatePipe } from '@ngx-translate/core';
import { NgCircleProgressModule } from 'ng-circle-progress';

@Component({
  selector: 'app-function-parameters-settings-clock-pompe-vsscreen',
  templateUrl:
    './function-parameters-settings-clock-pompe-vsscreen.component.html',
  styleUrls: [
    './function-parameters-settings-clock-pompe-vsscreen.component.scss',
  ],
  imports: [
    IonContent,
    GlobalPageHeaderComponent,
    TranslatePipe,
    IonButton,
    NgCircleProgressModule,
    IonLabel,
    IonList,
    IonItem,
    IonModal,
    IonFooter,
  ],
})
export class FunctionParametersSettingsClockPompeVSScreenComponent
  implements OnInit
{
  private modalController = inject(ModalController);

  @Input() value: string = '';
  public valueResult: string = '';

  public weekDay: number = 0;
  public horlogeModels: any = [];
  public selectModel: VSHorlogeModel | null = null;
  public selectModelStep: number = 0;

  isModalOpen = false;

  constructor() {}

  public list: any = [];
  public minuteInterval: number = 30;

  ngOnInit() {
    for (let i = 0; i < 60 * 24; i = i + this.minuteInterval) {
      this.list.push({ label: convertMinutesToTime(i), ref: i * 60 });
    }

    this.valueResult = this.value;

    this.horlogeModels = transformPompeVSWeekBufferToModel(this.valueResult);
  }

  onCloseSelectTimeIntervalChoice(
    ref: number,
    startDate: number,
    endDate: number,
    vitesse: number,
  ) {
    this.isModalOpen = false;

    if (ref == -1) {
      this.horlogeModels[this.weekDay].push({
        ref: this.horlogeModels[this.weekDay].length + 1,
        start: startDate,
        end: endDate,
        vitesse: vitesse,
      });
    } else {
      for (let i = 0; i < this.horlogeModels[this.weekDay].length; i++) {
        if (this.horlogeModels[this.weekDay][i].ref == ref) {
          this.horlogeModels[this.weekDay][i].start = startDate;
          this.horlogeModels[this.weekDay][i].end = endDate;
          this.horlogeModels[this.weekDay][i].vitesse = vitesse;
        }
      }
    }

    const buf = transformPompeVSWeekModelToBuffer(this.horlogeModels);
    this.valueResult = buf;
    this.horlogeModels = transformPompeVSWeekBufferToModel(buf);
  }

  secondeToHourMinute(time: number) {
    let h = Math.floor(time / (60 * 60));
    let m = Math.floor((time - h * 3600) / 60);

    return h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0');
  }

  tempsTotal() {
    const time = getHorlogeTotalTime(this.horlogeModels[this.weekDay]);
    return this.secondeToHourMinute(time);
  }

  setWeekDays(wekDay: number) {
    this.weekDay = wekDay;
  }

  onCloseSelectTimeIntervalRemove(ref: number) {
    for (let i = 0; i < this.horlogeModels[this.weekDay].length; i++) {
      if (this.horlogeModels[this.weekDay][i].ref == ref) {
        this.horlogeModels[this.weekDay].splice(i, 1);

        const buf = transformPompeVSWeekModelToBuffer(this.horlogeModels);
        this.valueResult = buf;
        this.horlogeModels = transformPompeVSWeekBufferToModel(buf);
        break;
      }
    }

    this.isModalOpen = false;
  }

  transformNumberToDegree(num: number) {
    return (num * 360) / (60 * 60 * 24);
  }

  selectVitesse(value: number) {
    this.selectModel!.vitesse = value;
  }

  nextStep() {
    this.selectModelStep = this.selectModelStep + 1;
  }

  goToStep(step: number) {
    this.selectModelStep = step;
  }

  selectStart(value: number) {
    this.selectModel!.start = value;
  }

  selectEnd(value: number) {
    this.selectModel!.end = value;
  }

  openModal(selectModel: VSHorlogeModel | null = null) {
    if (selectModel == null) {
      let hourStr = Moment().format('HH');
      this.selectModelStep = 0;
      this.selectModel = {
        ref: -1,
        start: parseInt(hourStr) * 3600,
        end: ((parseInt(hourStr) + 1) % 24) * 3600,
        vitesse: 0,
      };
    } else {
      this.selectModel = JSON.parse(JSON.stringify(selectModel));
      this.selectModelStep = 3;
    }

    this.isModalOpen = true;
  }

  deleteModel() {
    this.onCloseSelectTimeIntervalRemove(this.selectModel!.ref);
  }

  saveModel() {
    this.onCloseSelectTimeIntervalChoice(
      this.selectModel!.ref,
      this.selectModel!.start,
      this.selectModel!.end,
      this.selectModel!.vitesse,
    );
  }

  closeModal() {
    this.isModalOpen = false;
    this.selectModel = null;
  }

  async dismissModal(): Promise<void> {
    await this.modalController.dismiss({ value: this.valueResult });
  }

  getDataFromVitesse(vitesse: number) {
    if (vitesse == 1)
      return {
        h: 15,
        c: (AppComponent.currentBrand?.getMainColor() ?? '#f39200') + '77',
      };
    else if (vitesse == 2)
      return {
        h: 25,
        c: (AppComponent.currentBrand?.getMainColor() ?? '#f39200') + 'BB',
      };
    else if (vitesse == 3)
      return {
        h: 35,
        c: (AppComponent.currentBrand?.getMainColor() ?? '#f39200') + 'FF',
      };
    else if (vitesse == 4)
      return {
        h: 35,
        c: '#2e86abFF',
      };
    else
      return {
        h: 35,
        c: (AppComponent.currentBrand?.getMainColor() ?? '#f39200') + '00',
      };
  }

  getStartDate() {
    return moment.utc(this.selectModel!.start! * 1000).format('HH:mm');
  }
  getEndDate() {
    return moment.utc(this.selectModel!.end! * 1000).format('HH:mm');
  }
}
